export interface CreateGorgiasGuestEmailChallengeRequest {
  email: string;
}

export interface CreateGorgiasGuestEmailChallengeResponse {
  success: boolean;
  message: string;
  email: string;
  deliveryMethod: 'email';
  status?: string;
}

export interface VerifyGorgiasGuestEmailChallengeRequest {
  email: string;
  code: string;
}

export interface VerifyGorgiasGuestEmailChallengeResponse {
  success: boolean;
  message: string;
  email: string;
  externalId: string;
  expiresAt: string;
}

export interface CreateGorgiasAuthenticatedSessionIdentityResponse {
  success: boolean;
  message: string;
  email: string;
  externalId: string;
  expiresAt: string;
}
